import { networkReport } from '@/common/api/omReport'
import { NETWORK_STATUS } from '@/common/constants/networkStatus'
import { requestIdleCallbackPolyfill } from './polyfill'
import timeoutWorker from '../timeoutWorker'
import { loganLog } from '@RootCommon/utils/logan'
import { owlReportMetricsWeb } from '@RootCommon/utils/owl'
import { getLoginShopid } from '@RootCommon/utils'

const DEFAULT_REPORT_GAP_TIME = 600000 // 兜底10分钟上报一次

const TRIGGER_SRC = 'CMD'

const apiList = [
  // 'https://fooddelivery.mykeeta.com/api/v1/base/apitest',
]
const imgList = [
  'https://s3-fra01-eu.mykeeta.net/sailorfempcpublic/network_test.png',
]
function getNetworkDelayTimeFromApi (apiUrl: string): Promise<{ time: number; httpCode: number }> {
  return new Promise(resolve => {
    const startTime = Date.now()
    // 添加时间戳参数防止缓存
    const urlWithTimestamp = `${apiUrl}`
    fetch(urlWithTimestamp, {
      cache: 'no-store', // 禁用缓存
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    })
      .then(res => {
        const endTime = Date.now()
        resolve({
          time: endTime - startTime,
          httpCode: res.status,
        })
      })
      .catch(e =>
        resolve({
          time: -1,
          httpCode: 0,
        }),
      )
  })
}

function getNetworkStatus (delayTime: number) {
  if (delayTime <= 0) return NETWORK_STATUS.UNKNOWN
  if (delayTime <= 100) return NETWORK_STATUS.GOOD
  if (delayTime <= 300) return NETWORK_STATUS.MODERATE
  return NETWORK_STATUS.BAD
}

export async function getNetworkInfo () {
  const urlTime: Array<{ time: number; httpCode: number; url: string }> = []
  const apiResults = await Promise.all(apiList.map(apiUrl => getNetworkDelayTimeFromApi(apiUrl)))
  apiResults.forEach((fetchRes, index) => {
    if (fetchRes.time !== -1) {
      urlTime.push({
        time: fetchRes.time,
        httpCode: fetchRes.httpCode,
        url: apiList[index],
      })
    }
  })

  const delayTimes = await Promise.all(imgList.map(getNetworkDelayTimeFromApi))
  delayTimes.forEach((fetchRes, index) => {
    if (fetchRes.time !== -1) {
      urlTime.push({
        time: fetchRes.time,
        httpCode: fetchRes.httpCode,
        url: imgList[index],
      })
    }
  })
  const validDelayTimes = urlTime.filter(item => item.time !== -1)
  const averageDelayTime = validDelayTimes.length > 0 ? validDelayTimes.reduce((a, b) => a + b.time, 0) / validDelayTimes.length : 99999

  return {
    netStatus: getNetworkStatus(averageDelayTime),
    trigger: TRIGGER_SRC,
    urlTime,
  }
}

export async function reportNetwork (deviceType: number, isFirstCall = true) {
  const shopId = getLoginShopid()
  if (shopId <= 0) {
    return
  }

  const executeReport = async () => {
    // raptor上报 - 网络上报触发数
    owlReportMetricsWeb({ 'network_report_trigger': 1 })
    loganLog({ msg: '网络上报触发', shopId })
    let reportGapTime = DEFAULT_REPORT_GAP_TIME
    try {
      const networkInfo = await getNetworkInfo()
      const res = await networkReport(deviceType, networkInfo)
      reportGapTime = res.reportGapTime ? res.reportGapTime * 1000 : DEFAULT_REPORT_GAP_TIME
      // raptor上报 - 网络上报成功数
      owlReportMetricsWeb({ 'network_report_success': 1 })
      loganLog({ msg: '网络上报成功', networkInfo })
    } catch (error) {
      // raptor上报 - 网络上报失败数
      owlReportMetricsWeb({ 'network_report_error': 1 })
      loganLog({ msg: '网络上报接口调用失败', error: JSON.stringify(error) })
    }

    timeoutWorker.setTimeout(reportGapTime, () => {
      reportNetwork(deviceType, false)
    })
  }

  if (isFirstCall) {
    (window.requestIdleCallback || requestIdleCallbackPolyfill)(executeReport)
  } else {
    executeReport()
  }
}
